import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { SiteHeadersComponent } from './_layouts/site-headers/site-headers.component';
import { SiteFooterComponent } from './_layouts/site-footer/site-footer.component';
import { SpinnerComponent } from './_layouts/spinner/spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { DecryptionInterceptor } from './_helpers/decryption.interceptor';
import { DecryptionService } from './services/decryption.service';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { dataReducer } from './store/reducer';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AddVideoComponent } from './add-video/add-video.component';
import { AngularEditorModule } from '@kolkov/angular-editor';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    const nextState = reducer(state, action);
    localStorage.setItem('appState', JSON.stringify(nextState));
    return nextState;
  };
}

export function getInitialState() {
  const savedState = localStorage.getItem('appState');
  return savedState ? JSON.parse(savedState) : undefined;
}

const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    SiteHeadersComponent,
    SiteFooterComponent,
    HttpClientModule,
    NgxChartsModule,
    TooltipModule,
    AngularEditorModule,
    SpinnerComponent,
    NgxDaterangepickerMd.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    NgxSpinnerModule,
    StoreModule.forRoot({ appState: dataReducer }, { metaReducers, initialState: getInitialState() }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: false })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: DecryptionInterceptor, multi: true },
    //DecryptionService,
    DatePipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
